import {
    getCarAllListRequest,
    getCarAllRequest,
    getCarNoAccountListRequest,
    getCarNoAccountRequest,
    getCarAllListCountRequest,
} from '../../../../services/network/sell/all/car';

class CommonCarAllService {
    async getCarAll(id) {
        return await getCarAllRequest(id);
    }

    async getCarAllList(payload) {
        return await getCarAllListRequest(payload);
    }

    async getCarNoAccount(id) {
        return await getCarNoAccountRequest(id);
    }

    async getCarNoAccountList(payload) {
        return await getCarNoAccountListRequest(payload);
    }

    async getCarAllListCount() {
        return await getCarAllListCountRequest();
    }
}

export const CarAllService = new CommonCarAllService();
